import { RandomGenerator } from "../test-utils";
var TicketTechnicalDataBuilder = /** @class */ (function () {
    function TicketTechnicalDataBuilder() {
        this.ticketTechnicalData = {
            network: {
                ispName: RandomGenerator.randomString(),
                ip: RandomGenerator.randomString(),
                ipUserType: RandomGenerator.randomString(),
                asNumber: RandomGenerator.randomString(),
                organization: RandomGenerator.randomString(),
                domain: RandomGenerator.randomString(),
                netSpeed: RandomGenerator.randomString(),
            },
            geoLocation: {
                timezone: RandomGenerator.randomString(),
                country: RandomGenerator.randomString(),
                continent: RandomGenerator.randomString(),
                postalCode: RandomGenerator.randomString(),
                regionName: RandomGenerator.randomString(),
                city: RandomGenerator.randomString(),
                longitude: RandomGenerator.randomNumber(1, 1000000),
                latitude: RandomGenerator.randomNumber(1, 1000000),
            },
            systemAndBrowser: {
                osName: RandomGenerator.randomString(),
                osFamily: RandomGenerator.randomString(),
                browserName: RandomGenerator.randomString(),
                browserFamily: RandomGenerator.randomString(),
                userAgent: RandomGenerator.randomString(),
            }
        };
    }
    TicketTechnicalDataBuilder.prototype.withNetwork = function (network) {
        this.ticketTechnicalData.network = network;
        return this;
    };
    TicketTechnicalDataBuilder.prototype.withGeoLocation = function (geoLocation) {
        this.ticketTechnicalData.geoLocation = geoLocation;
        return this;
    };
    TicketTechnicalDataBuilder.prototype.withSystemAndBrowser = function (systemAndBrowser) {
        this.ticketTechnicalData.systemAndBrowser = systemAndBrowser;
        return this;
    };
    TicketTechnicalDataBuilder.prototype.build = function () {
        return this.ticketTechnicalData;
    };
    return TicketTechnicalDataBuilder;
}());
export { TicketTechnicalDataBuilder };
//# sourceMappingURL=ticket-technical-data.builder.js.map